<div (click)="changeToOnline()" *ngIf="!isOnline" [class]="'network-icon'" [matTooltip]="'offlineHeader.switchToOnline' | translate" data-testid="switch-online">
  <svg>
    <use xlink:href="assets/icons/networkOffline.svg#networkOffline" href="assets/icons/networkOffline.svg#networkOffline"/>
  </svg>
</div>

<div (click)="changeToOffline()" *ngIf="isOnline" [class]="'network-icon'" [matTooltip]="'offlineHeader.switchToOffline' | translate" data-testid="switch-offline">
  <svg>
    <use xlink:href="assets/icons/networkOnline.svg#networkOnline" href="assets/icons/networkOnline.svg#networkOnline"/>
  </svg>
</div>
